import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { GlobalsService } from '../../services/globals.service';
import { InventoryService } from 'app/services/inventory.service';
import { CustomerService } from 'app/services/customer.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { isArray } from 'chart.js/helpers';
import { animate, style, transition, trigger } from '@angular/animations';
import * as XLSX from 'xlsx';

@Component({
	selector: 'app-sticker-feed-control',
	templateUrl: './sticker-feed-control.component.html',
	styleUrls: ['./sticker-feed-control.component.scss'],
	animations: [
		trigger('fade', [
			transition(':enter', [style({ opacity: 0 }), animate('200ms 150ms ease-in', style({ opacity: 1 }))]),
			transition(':leave', [animate('150ms ease-out', style({ opacity: 0 }))]),
		]),
	]
})
export class StickerFeedControlComponent implements OnInit {

	clients: any[] = [];
	loading = true;
	saving: { [key: string]: boolean } = {};
	saved: { [key: string]: boolean } = {};
	saveError: { [key: string]: string } = {};
	newBrand: { [key: string]: string } = {};
	brands: any = false;
	stockidUploadError: { [key: string]: string } = {};

	debtorSearchTerm: { [key: string]: string } = {};
	debtorSearchResults: { [key: string]: any[] } = {};
	debtorSearching: { [key: string]: boolean } = {};
	branchOptions: { [key: string]: any[] } = {};
	debtorSearchSub: any = null;

	shipviaOptions: any[] = [];

	labels_used: any = [];
	label_in_use: Boolean = false;
	
	keys_used: any = [];
	key_in_use: Boolean = false;

	analytics_icon: SafeHtml;
	orders_icon: SafeHtml;
	settings_icon: SafeHtml;
	viewing_icon: SafeHtml;
	ping_icon: SafeHtml;

	copying: any = false;

	logs: { [key: string]: any[] } = {};
	logsLoading: { [key: string]: boolean } = {};
	logsError: { [key: string]: string } = {};
	logsPage: { [key: string]: number } = {};
	logsTotal: { [key: string]: number } = {};
	logsDateFrom: { [key: string]: string } = {};
	logsDateTo: { [key: string]: string } = {};
	readonly logsPageSize = 25;

	constructor(private globals: GlobalsService, private inventoryService: InventoryService, private customerService: CustomerService, private sanitizer: DomSanitizer, private globalSearchService: GlobalSearchService) {
		this.analytics_icon = this.sanitizer.bypassSecurityTrustHtml('<rect x="10" y="34" width="10" height="20" rx="2" fill="currentColor"/> <rect x="27" y="22" width="10" height="32" rx="2" fill="currentColor"/> <rect x="44" y="10" width="10" height="44" rx="2" fill="currentColor"/> <path d="M10 28 L27 16 L37 20 L54 6" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" fill="none" opacity="0.6"/>');
		this.viewing_icon = this.sanitizer.bypassSecurityTrustHtml( '<path d="M4 32 Q32 8 60 32 Q32 56 4 32 Z" fill="none" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/>' + '<circle cx="32" cy="32" r="10" fill="currentColor"/>' );
		this.orders_icon = this.sanitizer.bypassSecurityTrustHtml( '<rect x="14" y="10" width="30" height="44" rx="4" fill="none" stroke="currentColor" stroke-width="4"/>' + '<line x1="20" y1="24" x2="38" y2="24" stroke="currentColor" stroke-width="3" opacity="0.6"/>' + '<line x1="20" y1="34" x2="38" y2="34" stroke="currentColor" stroke-width="3" opacity="0.6"/>' + '<line x1="20" y1="44" x2="32" y2="44" stroke="currentColor" stroke-width="3" opacity="0.6"/>' + '<circle cx="46" cy="14" r="11" fill="currentColor"/>' + '<text x="46" y="19" font-size="14" font-weight="bold" fill="white" text-anchor="middle" font-family="sans-serif">#</text>' );
		this.settings_icon = this.sanitizer.bypassSecurityTrustHtml( '<line x1="10" y1="16" x2="54" y2="16" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>' + '<circle cx="24" cy="16" r="6" fill="currentColor"/>' + '<line x1="10" y1="32" x2="54" y2="32" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>' + '<circle cx="40" cy="32" r="6" fill="currentColor"/>' + '<line x1="10" y1="48" x2="54" y2="48" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>' + '<circle cx="20" cy="48" r="6" fill="currentColor"/>');
		this.ping_icon = this.sanitizer.bypassSecurityTrustHtml( '<line x1="10" y1="16" x2="54" y2="16" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>' + '<circle cx="24" cy="16" r="6" fill="currentColor"/>' + '<line x1="10" y1="32" x2="54" y2="32" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>' + '<circle cx="40" cy="32" r="6" fill="currentColor"/>' + '<line x1="10" y1="48" x2="54" y2="48" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>' + '<circle cx="20" cy="48" r="6" fill="currentColor"/>');
	}

	ngOnInit(): void {
		this.load();
		this.globalSearchService.shipvia.subscribe((results: any) => {
			this.shipviaOptions = Array.isArray(results) ? results : [];
		});
	}

	// card close fade duration (ms) - must match the .is-closing opacity transition in the scss
	private readonly CARD_CLOSE_DURATION = 250;

	flipClientCard(client, type){
		//type = settings (form for editing vendors - uses save to update information)|| analytics is the client-scoped connection log
		// the footer icons that call this are only shown while the card is not focused, so this always opens
		client.closing = false;
		client.viewing = type;
		client.focused = true;

		if (type === 'analytics') {
			this.loadLogs(client);
		}
	}

	loadLogs(vendor: any, page: number = 1) {
		const key = vendor.vendor_key;
		this.logsLoading[key] = true;
		this.logsError[key] = '';
		this.logsPage[key] = page;

		this.globals.getFeedConnectionLogs(vendor.id, {
			page,
			page_size: this.logsPageSize,
			date_from: this.logsDateFrom[key] || '',
			date_to: this.logsDateTo[key] || ''
		}).subscribe((result: any) => {
			this.logsLoading[key] = false;
			if (!result || result.success === false) {
				this.logsError[key] = (result && result.error) || 'Failed to load logs';
				return;
			}
			this.logs[key] = result.logs || [];
			this.logsTotal[key] = result.total || 0;
		}, (err) => {
			this.logsLoading[key] = false;
			this.logsError[key] = 'Failed to load logs (' + (err?.status || 'network error') + ')';
		});
	}

	searchLogs(vendor: any) {
		this.loadLogs(vendor, 1);
	}

	logsTotalPages(vendor: any): number {
		return Math.max(1, Math.ceil((this.logsTotal[vendor.vendor_key] || 0) / this.logsPageSize));
	}

	logsPrevPage(vendor: any) {
		const key = vendor.vendor_key;
		if ((this.logsPage[key] || 1) > 1) {
			this.loadLogs(vendor, (this.logsPage[key] || 1) - 1);
		}
	}

	logsNextPage(vendor: any) {
		const key = vendor.vendor_key;
		if ((this.logsPage[key] || 1) < this.logsTotalPages(vendor)) {
			this.loadLogs(vendor, (this.logsPage[key] || 1) + 1);
		}
	}

	formatLogTimestamp(dt: string): string {
		if (!dt) { return ''; }
		const [datePart, timePart] = dt.split(' ');
		if (!timePart) { return dt; }
		const [year, month, day] = datePart.split('-');
		let [hour, minute, second] = timePart.split(':');
		let hourNum = parseInt(hour, 10);
		const am = hourNum >= 12 ? 'pm' : 'am';
		hourNum = hourNum % 12 > 0 ? hourNum % 12 : 12;
		return `${month}/${day}/${year} ${hourNum}:${minute}:${second}${am}`;
	}

	closeExpanded(){
		const focusedClient = this.clients.find((c) => c.focused);
		if (focusedClient) {
			this.collapseClient(focusedClient);
		}
	}

	private collapseClient(client){
		// keep .is-focused (fixed/centered) applied and keep `viewing` intact while it
		// fades out in place, so it doesn't drop back into the flex flow - and swap
		// slots with its placeholder - until it's fully invisible. Avoids a moment
		// where both the placeholder and the card occupy a flow slot at once.
		client.closing = true;
		setTimeout(() => {
			client.focused = false;
			client.closing = false;
			client.viewing = '';
		}, this.CARD_CLOSE_DURATION);
	}

	get anyExpanded(): boolean {
		return this.clients.some((c) => c.focused);
	}

	load() {
		this.loading = true;
		this.globals.getFeedExclusions().subscribe((result: any) => {
			this.clients = result.vendors || [];
			this.keys_used = result.vendor_keys;
			this.labels_used = result.vendor_labels;
			this.loading = false;
			this.formatvendors();

			console.log(`sticker feeds result`, result);
		});

		this.inventoryService.getBrands().subscribe((res: any)=>{
			this.brands = res;
		})
	}


	formatvendors(){
		this.clients.forEach((v: any)=>{
			v.excluded_brands = isArray(v.excluded_brands) ? v.excluded_brands : [];
			v.excluded_stockids = isArray(v.excluded_stockids) ? v.excluded_stockids : [];

			const shipvia = isArray(v.shipvia) ? v.shipvia : [];
			v.allowed_shipvia = shipvia.map((s: any) => s.shipper_id);
			v.shipvia_freight = {};
			v.shipvia_requires_label = {};
			shipvia.forEach((s: any) => {
				v.shipvia_freight[s.shipper_id] = s.freight_price || '';
				v.shipvia_requires_label[s.shipper_id] = !!s.requires_label;
			});

			v.api_endpoints = isArray(v.api_endpoints) ? v.api_endpoints : [];
			v.allowed_endpoints = isArray(v.api_endpoints_allowed) ? v.api_endpoints_allowed : [];

			v.showItemPicker = false;
			v.showBrandEditor = false;
			v.brandFilter = '';
			v.password = '';
			v.viewing = '';

			if(v.lastsent != '' && v.lastsent){
				const [datePart, timePart] = v.lastsent.split(' ');
				const [year, month, day] = datePart.split('-');
				let [hour, minute] = timePart.split(':');
				let am = 'am'
				if(hour > 12){
					am = 'pm'
					hour = hour % 12 > 0 ? hour % 12 : 12;
				}
				v.lastsent = `${month}/${day} ${hour}:${minute}${am}`;
			}else{
				v.lastsent = 'never';
			}
			

			v.protocol = v.protocol || '';
			v.protocol_type = v.protocol_type || '';
			v.port = v.port || '';
			v.filename = v.filename || '';
			v.emailcopy = !!(+v.emailcopy);
			v.blankstartrow = !!(+v.blankstartrow);

			v.connection_type = v.connection_type || 'ftp';
			v.auth_type = v.auth_type || 'oauth2_client_credentials';
			v.client_id = v.client_id || '';
			v.revealed = null;
			v.generatingCredentials = false;

			v.debtorno = v.debtorno || '';
			v.branchcode = v.branchcode || '';
			v.debtor_name = v.debtor_name || '';
			v.branch_name = v.branch_name || '';
			this.debtorSearchTerm[v.vendor_key] = v.debtorno ? this.displayDebtorFn({ debtorno: v.debtorno, name: v.debtor_name }) : '';

			v.focused = false;
			v.closing = false;

			v.status = this.computeStatus(v);

			if (v.debtorno) {
				this.loadBranches(v);
			}
		})
	}

	debtorSearch(term: string, vendor: any) {
		if (this.debtorSearchSub) { this.debtorSearchSub.unsubscribe(); }
		if (!term || term.length < 1) { this.debtorSearchResults[vendor.vendor_key] = []; return; }
		this.debtorSearching[vendor.vendor_key] = true;
		this.debtorSearchSub = this.customerService.getCustomerSearch({
			source: 'stickerfeed',
			keywords: term
		}).subscribe((results: any) => {
			this.debtorSearching[vendor.vendor_key] = false;
			this.debtorSearchResults[vendor.vendor_key] = Array.isArray(results) ? results : [];
		}, () => { this.debtorSearching[vendor.vendor_key] = false; });
	}

	displayDebtorFn(c: any): string {
		return c ? `${c.debtorno} — ${c.name || ''}` : '';
	}

	selectDebtor(vendor: any, customer: any) {
		vendor.debtorno = customer.debtorno;
		vendor.debtor_name = customer.name || '';
		vendor.branchcode = '';
		vendor.branch_name = '';
		this.debtorSearchTerm[vendor.vendor_key] = this.displayDebtorFn(customer);
		this.branchOptions[vendor.vendor_key] = [];
		this.loadBranches(vendor);
	}

	loadBranches(vendor: any) {
		if (!vendor.debtorno) { return; }
		this.customerService.getBranches(vendor.debtorno).subscribe((branches: any) => {
			this.branchOptions[vendor.vendor_key] = Array.isArray(branches) ? branches : [];
		});
	}

	onBranchSelected(vendor: any, branchcode: string) {
		const match = (this.branchOptions[vendor.vendor_key] || []).find((b: any) => b.branchcode === branchcode);
		vendor.branch_name = match ? match.brname : '';
	}

	private computeStatus(v: any): string {
		if (v.connection_type === 'api') {
			const hasCredentials = v.auth_type === 'static_bearer'
				? !!v.access_token_set
				: !!(v.client_id && v.client_secret_set);
			return hasCredentials ? 'green' : 'red';
		}

		const creds = [v.password_set, v.username, v.serverhost].filter(Boolean).length;
		if (creds === 3) return 'green';
		if (creds === 0) return 'red';
		return 'yellow';
	}

	generateCredentials(vendor: any) {
		vendor.generatingCredentials = true;
		vendor.revealed = null;
		this.globals.generateFeedCredentials({ id: vendor.id, auth_type: vendor.auth_type }).subscribe((result: any) => {
			vendor.generatingCredentials = false;
			if (!result || result.success === false) {
				this.saveError[vendor.vendor_key] = (result && result.error) || 'Failed to generate credentials';
				return;
			}

			if (vendor.auth_type === 'static_bearer') {
				vendor.access_token_set = true;
				vendor.revealed = { bearer_token: result.bearer_token };
			} else {
				vendor.client_id = result.client_id;
				vendor.client_secret_set = true;
				vendor.revealed = { client_id: result.client_id, client_secret: result.client_secret };
			}

			vendor.status = this.computeStatus(vendor);
		}, (err) => {
			vendor.generatingCredentials = false;
			this.saveError[vendor.vendor_key] = 'Failed to generate credentials (' + (err?.status || 'network error') + ')';
		});
	}

	dismissRevealedCredentials(vendor: any) {
		vendor.revealed = null;
	}

	get stickerFeedTokenEndpoint(): string {
		return this.globals.getStickerFeedTokenEndpoint();
	}

	get stickerFeedFeedEndpoint(): string {
		return this.globals.getStickerFeedFeedEndpoint();
	}

	addBrand(vendor: any) {
		const brand = (this.newBrand[vendor.vendor_key] || '').trim().toUpperCase();
		if (!brand) return;
		if (!vendor.excluded_brands.includes(brand)) {
			vendor.excluded_brands = [...vendor.excluded_brands, brand];
		}
		this.newBrand[vendor.vendor_key] = '';
	}

	removeBrand(vendor: any, brand: string) {
		vendor.excluded_brands = vendor.excluded_brands.filter((b: string) => b !== brand);
		// this.updateVendor
	}

	filterBrands(vendor: any): any[] {
		if (!this.brands) return [];
		const term = (vendor.brandFilter || '').trim().toLowerCase();
		if (!term) return this.brands;
		return this.brands.filter((b: any) =>
			(b.name || '').toLowerCase().includes(term) ||
			(b.mfg_code || '').toString().toLowerCase().includes(term)
		);
	}

	toggleBrandEditor(vendor: any) {
		vendor.showBrandEditor = !vendor.showBrandEditor;
	}

	getBrandMfgCode(brandName: string): string {
		if (!this.brands) return '';
		const match = this.brands.find((b: any) => b.name === brandName);
		return match ? match.mfg_code : '';
	}

	toggleBrand(vendor: any, brand: string) {
		if (vendor.excluded_brands.includes(brand)) {
			this.removeBrand(vendor, brand);
		} else {
			vendor.excluded_brands = [...vendor.excluded_brands, brand];
		}
	}

	setAllBrands(vendor: any, excluded: boolean) {
		const visible = this.filterBrands(vendor).map((b: any) => b.name);
		if (excluded) {
			vendor.excluded_brands = [...new Set([...vendor.excluded_brands, ...visible])];
		} else {
			vendor.excluded_brands = vendor.excluded_brands.filter((b: string) => !visible.includes(b));
		}
	}

	toggleEndpoint(vendor: any, function_id: any) {
		if (vendor.allowed_endpoints.includes(function_id)) {
			vendor.allowed_endpoints = vendor.allowed_endpoints.filter((id: any) => id !== function_id);
		} else {
			vendor.allowed_endpoints = [...vendor.allowed_endpoints, function_id];
		}
	}

	onShipviaChange(vendor: any) {
		const freight: { [key: string]: any } = {};
		const requiresLabel: { [key: string]: boolean } = {};
		vendor.allowed_shipvia.forEach((id: any) => {
			freight[id] = vendor.shipvia_freight[id] != null ? vendor.shipvia_freight[id] : '';
			requiresLabel[id] = !!vendor.shipvia_requires_label[id];
		});
		vendor.shipvia_freight = freight;
		vendor.shipvia_requires_label = requiresLabel;
	}

	getShipperName(id: any): string {
		const match = this.shipviaOptions.find((s: any) => this.compareShipvia(s.shipper_id, id));
		return match ? match.shippername : '';
	}

	compareShipvia(a: any, b: any): boolean {
		return a != null && b != null && +a === +b;
	}

	save(vendor: any) {
		const sorted = [...new Set(vendor.excluded_brands)].sort((a: string, b: string)=>{
			if(a>b){return 1}
			if(a == b){return 0}
			if(a < b){return -1}
		})
		vendor.excluded_brands = sorted;

		const payload: any = {
			adding: vendor.adding,
			vendor_key: vendor.vendor_key,
			vendor_label: vendor.vendor_label,
			debtorno: vendor.debtorno || '',
			branchcode: vendor.branchcode || '',
			excluded_brands: sorted,
			excluded_stockids: vendor.excluded_stockids.map((i: any) => i.stockid),
			shipvia: vendor.allowed_shipvia.map((id: any) => ({
				shipper_id: id,
				freight_price: vendor.shipvia_freight[id] || 0,
				requires_label: !!vendor.shipvia_requires_label[id]
			})),
			username: vendor.username || '',
			serverhost: vendor.serverhost || '',
			path: vendor.path || '',
			protocol: vendor.protocol || '',
			protocol_type: vendor.protocol_type || '',
			port: vendor.port || '',
			filename: vendor.filename || '',
			emailcopy: vendor.emailcopy ? 1 : 0,
			blankstartrow: vendor.blankstartrow ? 1 : 0,
			connection_type: vendor.connection_type || 'ftp',
			auth_type: vendor.auth_type || '',
			api_endpoints_allowed: vendor.allowed_endpoints || []
		};

		if (vendor.password) {
			payload.password = vendor.password;
		}

		this.saving[vendor.vendor_key] = true;
		this.saved[vendor.vendor_key] = false;
		this.saveError[vendor.vendor_key] = '';
		this.globals.saveFeedExclusion(payload).subscribe((result: any) => {
			delete(vendor.adding)
			this.saving[vendor.vendor_key] = false;
			if (!result || result.success === false) {
				this.saveError[vendor.vendor_key] = (result && result.error) || 'Save failed';
				console.error('saveFeedExclusion failed', result);
				return;
			}
			this.saved[vendor.vendor_key] = true;
			if (vendor.password) {
				vendor.password_set = true;
			}
			vendor.password = '';

			vendor.status = this.computeStatus(vendor);

			console.log(`vendor post save`, vendor);
		}, (err) => {
			this.saving[vendor.vendor_key] = false;
			this.saveError[vendor.vendor_key] = 'Save failed (' + (err?.status || 'network error') + ')';
			console.error('saveFeedExclusion request error', err);
		});
	}


	deactivate(client){}

	removeclient(client){}

	keyCheck(e){
		const to_check = e.target.value;


		console.log(to_check, this.keys_used, this.keys_used.includes(to_check));
		
		if(this.keys_used.includes(to_check.toLowerCase())){
			this.key_in_use = true;
		}else{
			this.key_in_use = false;
		}
	}

	labelCheck(e){
		const to_check = e.target.value;
		if(this.labels_used.includes(to_check.toLowerCase())){
			this.label_in_use = true;
		}else{
			this.label_in_use = false;
		}
	}


	run(client: any = false){
		let data: any = false
		
		if(client){
			client.generating = true;
			data = {clients: [client.id]};
		}
		this.globals.runstickerfeed(data).subscribe((res)=>{
			console.log(res);
		})
	}

	addclient(){
		if(this.anyExpanded){
			this.closeExpanded()
		}

		//open dummy client
		this.clients.forEach(c => {
			if(c.id == 'new'){
				c.adding = true;
				c.viewing = 'settings';
				c.focused = true;
				c.closing = false;
				c.vendor_key = '';
				c.vendor_label = '';
				c.debtorno = '';
				c.branchcode = '';
				c.debtor_name = '';
				c.branch_name = '';
				c.allowed_shipvia = [];
				c.shipvia_freight = {};
				c.shipvia_requires_label = {};
				c.allowed_endpoints = [];
				this.debtorSearchTerm[c.vendor_key] = '';
				this.branchOptions[c.vendor_key] = [];
			}
		});
	}

	updateVendor(){}

	onKeydown(event: KeyboardEvent, vendor: any) {
		if (event.key === 'Enter') {
			this.addBrand(vendor);
		}
	}

	edit(v: any){
		this.clients.map((vend)=>{
			if(vend.id === v.id){
				if(!v.editing){
					v.editing = true
				}else{
					v.editing = false
				};
			}
		})
	}

	ping(client: any){
		const id = client.id
		client.pinging = true;
	
		this.globals.checkFeedConnection(id).subscribe((res: any)=>{
			client.pinging = false;	
			client.connection = res.connection;
			if(res.connection.success == true){
				this.updateclient(id, 'status', 'green')				
			}else{
				this.updateclient(id, 'status', 'red');
			}
		})
	}


	updateclient(id, field, value){
		this.clients.forEach((client)=>{
			if(client.id == id){
				client[field] = value;
			}
		})
	}


	toggleItemPicker(vendor: any){
		vendor.showItemPicker = !vendor.showItemPicker;
	}

	updateBlockedSkus(vendor: any, items: any[]){
		this.mergeStockIds(vendor, items);
		vendor.showItemPicker = false;
	}

	removeStockId(vendor: any, stockid: string) {
		vendor.excluded_stockids = vendor.excluded_stockids.filter((i: any) => i.stockid !== stockid);
	}

	copyfrom(client){
		client.copying = true;
		this.copying = {
			'brands' : client.excluded_brands,
			'skus' : client.excluded_stockids,
			'from' : client
		}
	}

	copyto(client){
		client.excluded_brands = this.copying['brands'];
		client.excluded_stockids = this.copying['skus'];
		this.save(client);
	}

	stopcopy(client){
		if(client.copying && this.copying){
			client.copying = false;
			this.copying = false;
		}
	}

	private mergeStockIds(vendor: any, items: any[]) {
		const merged = [...vendor.excluded_stockids];
		items.forEach((item: any) => {
			const stockid = (item.stockid || '').toString().trim();
			if (stockid && !merged.some((m: any) => m.stockid === stockid)) {
				merged.push({ stockid, description: item.description || '' });
			}
		});
		vendor.excluded_stockids = merged;
	}

	onStockIdFileSelect(event: Event, vendor: any) {
		const input = event.target as HTMLInputElement;
		const file = input.files?.[0];
		input.value = '';
		if (!file) return;

		this.stockidUploadError[vendor.vendor_key] = '';
		const ext = file.name.split('.').pop()?.toLowerCase();
		if (ext !== 'xlsx' && ext !== 'xls' && ext !== 'csv') {
			this.stockidUploadError[vendor.vendor_key] = 'Unsupported file type. Use .xlsx, .xls, or .csv';
			return;
		}

		const reader = new FileReader();
		reader.onload = (e) => {
			try {
				const data = new Uint8Array(e.target!.result as ArrayBuffer);
				const wb = XLSX.read(data, { type: 'array' });
				const ws = wb.Sheets[wb.SheetNames[0]];
				const rows = XLSX.utils.sheet_to_json<Record<string, any>>(ws, { defval: '' });

				if (!rows.length) {
					this.stockidUploadError[vendor.vendor_key] = 'File is empty';
					return;
				}

				const headerKey = Object.keys(rows[0]).find((h) => h.replace(/[\s_]+/g, '').toLowerCase() === 'stockid');
				if (!headerKey) {
					this.stockidUploadError[vendor.vendor_key] = 'No "stockid" column found in file';
					return;
				}

				const items = rows
					.map((r) => ({ stockid: (r[headerKey] || '').toString().trim(), description: '' }))
					.filter((r) => r.stockid);

				this.mergeStockIds(vendor, items);
			} catch {
				this.stockidUploadError[vendor.vendor_key] = 'Failed to parse file';
			}
		};
		reader.readAsArrayBuffer(file);
	}

	deactiveall(){
		const to_deactive = [];
		this.clients.forEach((c)=>{
			c.active = false;
			if(c.id !== 'new' && !c.adding){
				to_deactive.push(c.id);
			}
		});
	}
}
